/**
 * @copyright (C) 2024, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * SoonKi Min (skmin@rsupport.com)
 *
 * @description
 *
 * @created at Mon Feb 05 2024
 **/

export default function downloadBlobData(blob: Blob, fileName: string) {
	const link = document.createElement("a");
	const fileUrl = window.URL.createObjectURL(blob);
	link.setAttribute("target", "_blank");
	link.setAttribute("download", fileName);
	link.setAttribute("href", fileUrl);
	link.click();
	link.remove();
}
